import {Controller} from "stimulus"
import $ from 'jquery';


export default class extends Controller {

    initialize() {
        new window.WOW({live: false}).init()
    }
}